/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, April 8th 2022, 7:21:51 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { FormAPIFilters, FormConfiguration } from "lib/schemas";
import { PrimaryKeyValue } from "lib/types";
import { APISERVICEPATHS } from "lib/api";
import { AsyncAPIListAutoComplete, HelperText } from "ui-widgets";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormBuilderContext } from "form-builder/providers";
import { useFormsAPI } from "form-builder/services";
import { FileText as FileTextIcon } from "react-feather";
import { COLORSCHEME } from "theme/styles";
import { FORM_TYPES } from "lib/schemas";

export interface FormPickerProps {
  label: string;
  formId: PrimaryKeyValue<FormConfiguration>;
  handleChooseForm: (form: FormConfiguration) => void;
  formType?: keyof typeof FORM_TYPES;
  helpText?: string;
}

export const FormPicker = ({ label, formId, handleChooseForm, formType, helpText }: FormPickerProps) => {
  const { useAPIFetchForm } = useFormsAPI();
  const { apiItem: fetchedForm, isMakingAPIRequest: isFetchingForm } = useAPIFetchForm(formId, {
    makeRequestOnInitialMount: true,
  });

  const formTypeFilter = formType ? { form_type: formType } : {};

  const { formsAPIListFilter = {} } = useFormBuilderContext();

  const apiQueryParams: FormAPIFilters = { ...formsAPIListFilter, ...formTypeFilter };

  return (
    <>
      <AsyncAPIListAutoComplete<FormConfiguration>
        id="form-select-dropdown"
        label={label}
        itemIdProperty="id"
        getOptionLabel={(option) => option.title}
        loadingText="Loading Forms"
        onChangeCallBack={handleChooseForm}
        value={fetchedForm}
        apiServicePath={APISERVICEPATHS.forms}
        apiQueryParams={apiQueryParams}
        inputStartAdornment={isFetchingForm ? <CircularProgress /> : <FileTextIcon color={COLORSCHEME.primary} />}
        fullWidth
      />
      {helpText && <HelperText>{helpText}</HelperText>}
    </>
  );
};
